import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=26b45247&scoped=true&"
import script from "./resources.ts?vue&type=script&lang=ts&"
export * from "./resources.ts?vue&type=script&lang=ts&"
import style0 from "./resources.scss?vue&type=style&index=0&id=26b45247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b45247",
  null
  
)

export default component.exports